'use client';

import { useRouter } from 'next/navigation';
import { generateRoomId } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const startMeeting = () => {
    router.push(`/rooms/${generateRoomId()}`);
  };

  return (
    <main className={styles.main} data-lk-theme="default">
      <div className={styles.hero}>
        <div className={styles.logo} aria-label="Wavix">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="30"
            fill="none"
            viewBox="0 0 132 20"
            role="img"
            aria-label="Wavix logo"
          >
            <path
              fill="#34C1CA"
              d="m0 .294 7.19.005L16.21 19.65h-3.546a5.79 5.79 0 0 1-5.251-3.36z"
            />
            <path
              fill="#34CA5E"
              d="m10.152.299 7.19.004 9.022 19.352h-4.812a3.82 3.82 0 0 1-3.454-2.207zM20.45.303l7.106.005-1.187 12.673z"
            />
            <path
              fill="#fff"
              d="m32.762.312 5.654.005 2.094 10.86L43.502.317l5.659.004 3.056 10.888L54.242.326l5.595.004-3.317 15.038a5.49 5.49 0 0 1-5.357 4.31h-1.438l-3.35-12.224-2.273 8.198a5.49 5.49 0 0 1-5.287 4.026h-1.677zM73.6.33h-6.396l-7.317 19.343 6.07.005.977-3.195h6.9190000000000005l.971 3.195 6.071.005zm-5.397 12.004 2.195-7.184 2.186 7.188zM94.408.34 90.04 14.267 85.683.335H79.57l7.18 19.352h6.571L100.52.345zM108.573.345h-5.87v19.347h5.87zM125.389 9.612l5.97-9.254-6.4-.004-3.455 5.994-3.45-5.994-6.398-.005 5.962 9.258-6.626 10.09 6.548.004 3.964-6.357 3.954 6.362h6.543z"
            />
          </svg>
        </div>
        <h2 className={styles.tagline}>Internal Communication at Wavix</h2>
        <button className={`lk-button ${styles.startButton}`} onClick={startMeeting}>
          Start meeting
        </button>
      </div>
    </main>
  );
}
